import { Injectable } from '@angular/core';
import { BRANDS_URL } from '../../shared/constants/urls';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BrandsService {

  constructor(private readonly client: HttpClient) { }
  /**
   * function service is called to get brand from data base.
   */
  getBrands() {
    return this.client.get(BRANDS_URL);
  }
}
